export enum TaskListSectionModel {
    CONFIRMED_COMPLETE = 'Confirmed complete',
    DECLARED_COMPLETE = 'Declared complete',
    WORK_IN_PROCESS = 'Work in process',
    QUEUED = 'Queued',
    PENDING = 'Pending',
}